import styled, { css } from 'styled-components/macro'

import { WrapperProps, StepProps } from './@types'

export const Wrapper = styled.section<WrapperProps>`
  padding: 1.2rem 0.8rem;
  height: 4.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.6rem;
  border-bottom: 0.1rem solid ${(props) => props.theme.color.elementBorder};
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    padding: 1.2rem 3.2rem;
    gap: 4.6rem;
  `};
`

export const StyledStep = styled.div<StepProps>`
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: ${(props: any) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.2;
  letter-spacing: -0.018rem;
  color: ${(props) => props.theme.color.textThird};
  ${(props) =>
    props.active &&
    css`
      color: ${(props) => props.theme.color.warning};
    `}
  ${(props) =>
    props.completed &&
    !props.active &&
    css`
      color: ${(props) => props.theme.color.success};
    `}
  ${(props) => props.theme.breakpoints.greaterThan('xsm')`
    flex-direction: row;
    font-size: 1.8rem;
    line-height: 1;
  `};
`

export const StepCount = styled.span`
  font-size: inherit;
`

export const StepCountSeparator = styled.span`
  font-size: inherit;
  display: none;
  ${(props) => props.theme.breakpoints.greaterThan('xsm')`
    display: inline-block;
  `};
`

export const Divider = styled.span`
  font-size: 1.8rem;
  ${(props) => props.theme.breakpoints.greaterThan('xsm')`
    font-size: inherit;
  `};
`
